import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";
let proportion = class proportion extends Vue {
  constructor() {
    super(...arguments);
    this.newArr = [];
  }
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.item.optionsList.forEach(op => {
          let findAs = value.answer.find(oas => {
            return oas.id == op.id;
          });
          if (findAs) {
            op.proportion = findAs.proportion;
          }
        });
      }
    }
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
  get total() {
    return this.item.jsonConfig && this.item.jsonConfig.total;
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], proportion.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], proportion.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], proportion.prototype, "showScore", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], proportion.prototype, "businessType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], proportion.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], proportion.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], proportion.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], proportion.prototype, "dataChage", null);
proportion = __decorate([Component({
  name: "proportion"
})], proportion);
export default proportion;